import React from 'react'
import '../Pricing.scss'

const PricingCard = ({ headingLabel, currentPlans, expandedPlanId, handleTogglePlan }) => {
    return (
        <div className="pricing_section">
            <h2 className="pricing_section_title">{headingLabel}</h2>
            <div className="pricing_cards">
                {currentPlans.map((plan) => {
                    const isExpanded = expandedPlanId === plan.id
                    const hasDetails = plan.serviceSections && plan.serviceSections.length > 0

                    return (
                        <div key={plan.id} className={`pricing_card ${isExpanded ? 'expanded' : ''}`}>

                            <div className="pricing_card_icon"><img src={plan.icon} alt={plan.title} /></div>
                            <div className="pricing_card_content">
                                <h3 className="pricing_card_title">{plan.title}</h3>
                                <p className="pricing_card_frequency">({plan.frequency})</p>
                            </div>

                            <div className="pricing_card_price">
                                <span className="price_usd">{plan.priceUSD !== '' ? plan.priceUSD : plan.priceCustom}</span>
                                {plan.priceUSD !== '' && <span className="price_label">USD</span>}
                            </div>
                            <div className="pricing_card_price_inr">
                                <span className="price_inr">{plan.priceCustom !== '' && plan.priceCustom !== undefined ? "" : plan.priceINR !== '' ? plan.priceINR : 'Per Month'}</span>
                                {plan.priceINR !== '' && <span className="price_label_inr">Per Month</span>}
                            </div>
                            {hasDetails && (
                                <>
                                    <div className={`pricing_card_details ${isExpanded ? 'show' : ''}`}>
                                        {plan.serviceSections.map((section) => (
                                            <div key={section.title} className="detail_section">
                                                <div className="detail_section_header">
                                                    <span className="detail_section_bullet"><img src={section.icon} alt={section.title} /></span>
                                                    <span className="detail_section_title">{section.title}</span>
                                                </div>
                                                <ul className="detail_section_list">
                                                    {section.items.map((item) => (
                                                        <li key={item}>{item}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        ))}
                                    </div>

                                    <button
                                        className="pricing_card_button"
                                        onClick={() => handleTogglePlan(plan.id)}
                                        aria-expanded={isExpanded}
                                    >
                                        {isExpanded ? 'Show Less' : 'View all Services'}
                                        <svg
                                            className={isExpanded ? 'rotated' : ''}
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path d="M4 6L8 10L12 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </>
                            )}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default PricingCard
